<script>
import {config} from "@/config";

export default {
  name: "DeleteItem",
  props: ['item', 'confirmation'],
  data() {
    return {
      isDeletingGoods: false,
      isDeleting: false,
      modalConfirmOptions: {
        title: false,
        okTitle: 'Удалить',
        okVariant: 'danger',
        cancelTitle: 'Отменить',
        cancelVariant: 'success'
      }
    }
  },
  methods: {
    async deleteGoods() {
      if (!this.confirmation) {
        await this.$bvModal.msgBoxOk('Подтвердите удаление!')
        return false
      }
      let message = this.$createElement('div', {}, [this.$createElement('p', 'Вы пытаетесь удалить товар. После подтверждения этого действия, их нельзя будет восстановить.'), this.$createElement('p', 'Подтвердить удаление?')])
      this.$bvModal.msgBoxConfirm( message, this.modalConfirmOptions).then(value => {
        if (value) {
          let formData = new FormData();
          formData.append('file_id', this.item.id)
          formData.append('entity', 'products')
          let params = {
            data: formData,
            th: this
          };
          this.isDeletingGoods = true;
          this.$store.dispatch('bulkDelete/DELETE_PRODUCTS', params);
          this.isDeletingGoods = false;
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    deleteItem() {
      this.$bvModal.msgBoxConfirm( 'Вы действительно хотите удалить файл?', this.modalConfirmOptions).then(async value => {
        if (value) {
          let params = {
            id: this.item.id,
            th: this
          };
          this.isDeleting = true;
          await this.$store.dispatch('bulkDelete/DELETE_ITEM', params);
          this.isDeleting = false;
        }
      })
          .catch(err => {
            console.log(err)
          })
    },
    downloadLink(id) {
      return `${config.apiUrl}/bulk-delete/download/${id}/file_result/${this.getAuthToken}`
    }
  },
  computed: {
    getAuthToken: function () {
      return localStorage.authToken
    }
  }
}
</script>

<template>
  <div>
    <b-row class="mb-2">
      <b-col cols="6">
        <b-button
            block href="#"
            v-b-toggle="'accordion-'+ item.id"
            :variant="item.state ? 'success' : 'primary'"
        >
          {{ item.id }} - {{ item.file_name }} - {{ item.createdAt}}
        </b-button>
      </b-col>
      <b-col cols="2">
        <b-button
            block
            variant="danger"
            v-on:click="deleteGoods"
            :disabled="isDeletingGoods || item.state"
        >
          <span class="waiting-state" v-if="!isDeletingGoods">Удалить товары</span>
          <section class="process-state" v-if="isDeletingGoods">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Удаление ...
          </section>
        </b-button>
      </b-col>
      <b-col cols="2">
        <b-button
            block
            variant="danger"
            v-on:click="deleteItem"
            :disabled="isDeleting"
        >
          <span class="waiting-state" v-if="!isDeleting">Удалить файл</span>
          <section class="process-state" v-if="isDeleting">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Удаление ...
          </section>
        </b-button>
      </b-col>
      <b-col cols="2">
        <b-link
            class="btn btn-success w-100"
            variant="success"
            :href="downloadLink(item.id)"
            v-if="item.file_result_path"
        >
          Скачать отчет
        </b-link>
      </b-col>
    </b-row>
    <b-collapse :id="'accordion-'+ item.id" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <b-container fluid>
          <b-row>
            <b-col class="text-align-left col-4">

            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<style scoped>

</style>